<script>
export default {
  name: 'ChartBarIconWarning',
  props: {
    size: {
      type: [Number, String],
      default: 50,
    },
    color: {
      type: String,
      default: '#BA9309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" :fill="color" fill-opacity="0.2" />
    <path
      d="M38.0133 30.227L29.48 14.867C28.3333 12.8003 26.7466 11.667 25 11.667C23.2533 11.667 21.6666 12.8003 20.52 14.867L11.9866 30.227C10.9066 32.187 10.7866 34.067 11.6533 35.547C12.52 37.027 14.2266 37.8403 16.4666 37.8403H33.5333C35.7733 37.8403 37.48 37.027 38.3466 35.547C39.2133 34.067 39.0933 32.1737 38.0133 30.227ZM24 21.0003C24 20.4537 24.4533 20.0003 25 20.0003C25.5466 20.0003 26 20.4537 26 21.0003V27.667C26 28.2137 25.5466 28.667 25 28.667C24.4533 28.667 24 28.2137 24 27.667V21.0003ZM25.9466 32.6137C25.88 32.667 25.8133 32.7203 25.7466 32.7737C25.6666 32.827 25.5866 32.867 25.5066 32.8937C25.4266 32.9337 25.3466 32.9603 25.2533 32.9737C25.1733 32.987 25.08 33.0003 25 33.0003C24.92 33.0003 24.8266 32.987 24.7333 32.9737C24.6533 32.9603 24.5733 32.9337 24.4933 32.8937C24.4133 32.867 24.3333 32.827 24.2533 32.7737C24.1866 32.7203 24.12 32.667 24.0533 32.6137C23.8133 32.3603 23.6666 32.0137 23.6666 31.667C23.6666 31.3203 23.8133 30.9737 24.0533 30.7203C24.12 30.667 24.1866 30.6137 24.2533 30.5603C24.3333 30.507 24.4133 30.467 24.4933 30.4403C24.5733 30.4003 24.6533 30.3737 24.7333 30.3603C24.9066 30.3203 25.0933 30.3203 25.2533 30.3603C25.3466 30.3737 25.4266 30.4003 25.5066 30.4403C25.5866 30.467 25.6666 30.507 25.7466 30.5603C25.8133 30.6137 25.88 30.667 25.9466 30.7203C26.1866 30.9737 26.3333 31.3203 26.3333 31.667C26.3333 32.0137 26.1866 32.3603 25.9466 32.6137Z"
      :fill="color"
    />
  </svg>
</template>
